import { useEffect, useRef, useState } from "react";

/* IntersectionObserver + CSS scroll-reveal. Robust final state (no rAF-freeze),
   respects prefers-reduced-motion via CSS. */
export const Reveal = ({
  children,
  className = "",
  delay = 0,
  as: Tag = "div",
  ...rest
}) => {
  const ref = useRef(null);
  const [inView, setInView] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const io = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setInView(true);
          io.disconnect();
        }
      },
      { rootMargin: "0px 0px -8% 0px", threshold: 0.08 }
    );
    io.observe(el);
    return () => io.disconnect();
  }, []);

  return (
    <Tag
      ref={ref}
      className={`reveal ${inView ? "reveal-in" : ""} ${className}`}
      style={{ transitionDelay: `${delay}s` }}
      {...rest}
    >
      {children}
    </Tag>
  );
};

/* Masked line reveal — plays on load via CSS. */
export const MaskLine = ({ children, delay = 0, className = "" }) => (
  <span className="line-mask">
    <span
      className={"mask-inner " + className}
      style={{ animationDelay: `${delay}s` }}
    >
      {children}
    </span>
  </span>
);

export const EASE = [0.22, 1, 0.36, 1];
